import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("keydown", this.handleKeydown, true);
  }

  disconnect() {
    this.element.removeEventListener("keydown", this.handleKeydown, true);
  }

  handleKeydown = (event) => {
    const target = event.target;

    // --- Modal Focus Trap and Escape ---
    if (this.isModal()) {
      if (event.key === "Escape") {
        event.preventDefault();
        this.closeModal();
        return;
      }
      if (event.key === "Tab") {
        this.trapFocus(event);
        return;
      }
    }

    // --- Table Row Expand (TD as button) ---
    if (this.isExpandableRow(target)) {
      if (event.key === " " || event.key === "Enter") {
        event.preventDefault();
        const tr = target.closest("tr");
        if (tr) tr.click();
      }
      return;
    }

    // --- Button/Link Keyboard Activation ---
    if (this.isButtonOrLink(target)) {
      if (event.key === " ") {
        event.preventDefault();
        target.click();
      }
      return;
    }

    // --- Label Keyboard Activation for Checkbox ---
    if (this.isLabel(target)) {
      if (event.key === " " || event.key === "Enter") {
        event.preventDefault();
        this.toggleCheckboxFromLabel(target);
      }
      return;
    }
  };

  // --- Helper Methods ---

  isModal() {
    return (
      this.element.getAttribute("role") === "dialog" ||
      this.element.getAttribute("aria-modal") === "true"
    );
  }

  closeModal() {
    const closeBtn = this.element.querySelector('[data-action*="close"]');
    if (closeBtn) {
      closeBtn.click();
    } else {
      this.element.dispatchEvent(new CustomEvent("modal:close", { bubbles: true }));
    }
  }

  trapFocus(event) {
    const focusable = Array.from(
      this.element.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
    );
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    }
  }

  isExpandableRow(target) {
    return (
      target.tagName === "TD" &&
      target.getAttribute("role") === "button" &&
      target.tabIndex === 0
    );
  }

  isButtonOrLink(target) {
    return (
      (target.tagName === "A" || target.tagName === "BUTTON") &&
      (target.getAttribute("role") === "button" || target.tabIndex === 0)
    );
  }

  isLabel(target) {
    return target.tagName === "LABEL" && target.tabIndex === 0;
  }

  toggleCheckboxFromLabel(label) {
    const forId = label.getAttribute("for");
    if (forId) {
      const checkbox = document.getElementById(forId);
      if (checkbox) {
        checkbox.click();
        checkbox.focus();
      }
    }
  }
}
